$(document).ready(function () {
  const $toggles = $('.pmo_switch input[type="checkbox"]');
  const $priceDisplay = $(".pmo_atc_price");
  const $acceptButton = $(".pmo_accept");
  const $declineButton = $(".pmo_decline");

  function updateTotalPrice() {
    let totalPrice = 0;
    let anyProductSelected = false;

    $toggles.each(function () {
      if ($(this).is(":checked")) {
        totalPrice += parseInt($(this).data("product-price"));
        anyProductSelected = true;
      }
    });

    // Format price with 2 decimal places and currency symbol
    const formattedPrice = "$" + (totalPrice / 100).toFixed(2);
    $priceDisplay.html(formattedPrice);

    // Show/hide the accept button based on product selection
    if (anyProductSelected) {
      $acceptButton.show();
    } else {
      $acceptButton.hide();
    }
  }

  // Initial price calculation
  updateTotalPrice();

  // Add event listeners to all toggles
  $toggles.on("change", updateTotalPrice);
});
